import { useCallback, useEffect, useState } from 'react'
import { GraphQLCampaignRepository } from '../../../infrastructure/graphql/CampaignRepositoryImpl'
import { fetchCampaigns } from '../../../application/usecases/fetchCampaigns'
import { Campaign } from '../../../domain/entities/Campaign'
import { useAuth0 } from '@auth0/auth0-react'

export const useFetchCampaigns = () => {
  const { getIdTokenClaims } = useAuth0()
  const [data, setData] = useState<Campaign[]>([])
  const [loading, setLoading] = useState(true)

  const refetch = useCallback(async () => {
    setLoading(true)
    const getToken = async () => (await getIdTokenClaims())?.__raw ?? ''
    const repo = new GraphQLCampaignRepository(getToken)
    const list = await fetchCampaigns(repo)()
    setData(list)
    setLoading(false)
  }, [getIdTokenClaims])

  useEffect(() => {
    refetch()
  }, [refetch])

  return { data, loading, refetch }
}
